
import Vue from 'vue'
import ItemCard from './ItemCard.vue'
import {ProjectPage} from '@/model/Project'

export default Vue.extend({
  name: 'ProjectList',
  components: {
    ItemCard,
  },
  props: {
    showBookmarkAction: {
      type: Boolean,
      default: true,
    },
    showEditProjectIcon: {
      type: Boolean,
      default: false,
    },
    actionBaseName: {
      type: String,
    },
    orderDirection: {
      type: String,
    },
    filters: {
      type: Object,
    },
    removeFavourites: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.loadProjects()
  },
  data: () => ({
    items: [] as ProjectPage[],
    itemsPerPage: 16,
    currentPage: 1,
    totalPages: 1,
    loadNextPageLoading: false,
  }),
  methods: {
    requestParameters: function () {
      const params: any = {
        itemsPerPage: this.itemsPerPage,
        page: this.currentPage,
        sortBy: 'createdAt',
        sortDirection: this.orderDirection
      }

      if (this.filters.category && this.filters.category.id) {
        params['category'] = this.filters.category.id
      }

      if (this.filters.contest && this.filters.contest.id) {
        params['contestId'] = this.filters.contest.id
        params['applicationStatus'] = "accepted"
      }

      if (this.filters.tags && this.filters.tags.length > 0) {
        params.tags = this.filters.tags
            .map(tag => typeof tag === 'object' ? tag.id : tag)
            .join(',');
      }

      return params
    },
    loadProjects: function () {
      this.currentPage = 1
      this.$api
        .get(this.actionBaseName, { params: this.requestParameters() })
        .then((response) => {
          this.items = response.data['items']
          this.totalPages = Math.ceil(
            response.data['count'] / this.itemsPerPage
          )
        })
    },
    loadNextPage: function () {
      this.loadNextPageLoading = true
      const requestParameters = this.requestParameters()
      requestParameters.page++
      this.$api
        .get(this.actionBaseName, { params: requestParameters })
        .then((response) => {
          this.items = [...this.items, ...response.data['items']]
          this.currentPage++
          if (this.currentPage === this.totalPages) {
            this.$store.dispatch(
              'alert/info',
              'You have seen all projects already!'
            )
          }
        })
        .finally(() => (this.loadNextPageLoading = false))
    },
    bookmarkRemoved: function (projectItem: ProjectPage) {
      if (this.removeFavourites) {
        this.items.splice(this.items.indexOf(projectItem), 1)
      }
    },
  },
  watch: {
    orderDirection: function () {
      this.loadProjects()
    },
    filters: function () {
      this.loadProjects()
    },
  },
})
